<div class="property" *ngIf="_totalOnOpen | exists">
    <div class="name">Vorige totaal:</div>
    <div class="value">{{ _totalOnOpen | currency:'EUR':'':null:'nl' }}</div>
</div>
<div class="property" *ngIf="_currentTotal | exists">
    <div class="name">Huidige totaal:</div>
    <div class="value">{{ _currentTotal | currency:'EUR':'':null:'nl' }}</div>
</div>
<div class="property" *ngIf="_numHours | exists">
    <div class="name">Totaal uren:</div>
    <div class="value">{{ _numHours | number:'1.0-0': 'nl-NL' }}</div>
</div>
<div class="property" *ngIf="_numLines | exists">
    <div class="name">Aantal regels:</div>
    <div class="value">{{ _numLines | number:'1.0-0' }}</div>
</div>
<div class="property" *ngIf="_currentHourlyRate | exists">
    <div class="name">Uurloon:</div>
    <div class="value">{{ _currentHourlyRate | currency:'EUR':'':null:'nl' }}</div>
</div>
<div class="spacer"></div>

<div class="sync" *ngIf="_syncing">
    <i class="icon fas fa-sync"></i>
</div>
<div class="warnings" *ngIf="_numWarnings | exists">
    <i class="icon fas fa-exclamation-triangle"></i>
    <div class="amount">{{ _numWarnings | number:'1.0-0' }}</div>
</div>